import { Tooltip, TooltipProps } from '@mui/material';

export const ConditionalTooltip = ({
  shouldShow,
  children,
  ...tooltipProps
}: { shouldShow: boolean; children: JSX.Element } & TooltipProps) => {
  return shouldShow ? <Tooltip {...tooltipProps}>{children}</Tooltip> : children;
};
